import api from './api';

export interface VariableMetadataItem {
  name: string;
  label: string;
  source?: 'contact' | 'account' | 'agent';
}

export interface CustomVariableItem {
  name: string;
  label: string;
  default_value?: string;
}

export interface WhatsAppVariableMetadata {
  system_variables: VariableMetadataItem[];
  custom_variables: CustomVariableItem[];
}

export async function fetchWhatsAppVariableMetadata(accountId: number): Promise<WhatsAppVariableMetadata> {
  const res = await api.get('/whatsapp/variable-metadata', { params: { account_id: accountId } });
  return res.data;
}
